export default __webpack_public_path__ + "static/media/reports.d07937c3.png";